export default __webpack_public_path__ + "static/media/avatar.8532f55a.jpeg";